// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260746/js/" + chunkId + "." + {"44":"b8fb2ad6","225":"e56a9c2e","481":"955ae94d","486":"358fa8cc","770":"3070eb79"}[chunkId] + ".0.7221059926080724.chunk.js";
};